const GET_USER = 'flixfrenzy/redux/GET_USER';

// eslint-disable-next-line default-param-last
const userReducer = (state = { password: '1111ee' }, action) => {
  switch (action.type) {
    case GET_USER:
      return action.payload;
    default:
      return state;
  }
};

export const getUser = (user) => (dispatch) => {
  dispatch({
    type: GET_USER,
    payload: user,
  });
};

export default userReducer;
